import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { IsAutoplay } from "slotworks/state-machine/standard/decisions/is-autoplay";

export class IsTGRAutoplay extends IsAutoplay {

    public evaluate(): Exit.True | Exit.False {
        return Services.autoplay.isAutoPlaying() ? Exit.True : Exit.False;
    }
}
